import {CurrentUserData} from 'security';

export const hasPlacementAccess = (theUser: CurrentUserData | null): boolean => ['CLIENT_PLACEMENT_SPECIALIST', 'CLIENT_PLACEMENT_DECISION_MAKER', 'CLIENT_PLACEMENT_SPECIALIST_WITH_PROVIDER_SUPPORT', 'CLIENT_PLACEMENT_DECISION_MAKER_WITH_PROVIDER_SUPPORT'].includes(theUser?.role || '')

